import { ISaleSetActions } from "../../action-types/sale-set/ISaleSetActionType";
import { ISaleSetReducer } from "../../reducer-model/sale-set/ISaleSetReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";

const initialState: ISaleSetReducer = {
    status: eReducerStatusBase.is_not_initialization,
    saleSets: []
};

export const saleSetReducer = (state: ISaleSetReducer = initialState, action: ISaleSetActions): ISaleSetReducer => {
    switch (action.type) {
        case "SALE_SET_LOAD_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading
            }
        case "SALE_SET_LOAD_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                saleSets: action.payload
            }
        case "SALE_SET_LOAD_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            }
        case "SALE_SET_SHOW_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: true,
                saleSetEditing: action.payload
            }
        case "SALE_SET_CLOSE_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: false,
            }
        case "SALE_SET_SAVE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_saving
            }
        case "SALE_SET_SAVE_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
                isShowEditModal: false
            }
        case "SALE_SET_SAVE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            }
        case "SALE_SET_DELETE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_saving
            }
        case "SALE_SET_DELETE_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload
            }
        case "SALE_SET_DELETE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            }
        case "SALE_SET_LOAD_BY_HOCSINH_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading
            }
        case "SALE_SET_LOAD_BY_HOCSINH_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                saleSets: action.payload
            }
        case "SALE_SET_LOAD_BY_HOCSINH_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            }
        default:
            return state;
    }
};
